import { Button } from "@/components/ui/UIElements/Button";
import React from "react";
import { Icon } from "../../";
import { useIntegrationSync } from "../../../../hooks";

const SyncButtons = ({ businessId, integrationId, disabled = false }) => {
  const { syncBusiness, syncMenu, isSyncingBusiness, isSyncingMenu } =
    useIntegrationSync({ businessId, integrationId });

  const handleSyncBusiness = () => {
    syncBusiness();
  };

  const handleSyncMenu = () => {
    syncMenu();
  };

  return (
    <div className="flex gap-2">
      {/* Sync Business Button */}
      <Button
        variant="ghost"
        onClick={handleSyncBusiness}
        disabled={disabled || isSyncingBusiness}
        className="border-primary/30 bg-primary/20 hover:border-primary/50 hover:bg-primary/30 inline-flex flex-1 items-center justify-center rounded-lg border px-4 py-2 text-sm font-medium text-[var(--od-action-content)] transition-colors disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isSyncingBusiness ? (
          <div className="border-primary mr-2 h-4 w-4 animate-spin rounded-full border-b-2"></div>
        ) : (
          <Icon name="RefreshCw" className="mr-2 h-4 w-4" />
        )}
        Sync Business
      </Button>

      {/* Sync Menu Button */}
      <Button
        variant="ghost"
        onClick={handleSyncMenu}
        disabled={disabled || isSyncingMenu}
        className="border-primary/30 bg-primary/20 hover:border-primary/50 hover:bg-primary/30 inline-flex flex-1 items-center justify-center rounded-lg border px-4 py-2 text-sm font-medium text-[var(--od-action-content)] transition-colors disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isSyncingMenu ? (
          <div className="border-primary mr-2 h-4 w-4 animate-spin rounded-full border-b-2"></div>
        ) : (
          <Icon name="RefreshCw" className="mr-2 h-4 w-4" />
        )}
        Sync Menu
      </Button>
    </div>
  );
};

export default SyncButtons;
